import React, { FC } from "react";
import classNames from "classnames/dedupe";
import { IDropdownContext } from "../../../Utility";

export type ITooltipTriangleComponentProps = Partial<IDropdownContext>;

const TooltipTriangleComponent: FC<ITooltipTriangleComponentProps> = ({
  pos,
  currentPosition,
  currentAlignment,
}) => (
  <span
    data-testid="TooltipTriangle"
    className={classNames(
      "tooltip__triangles",
      `tooltip__triangles--pos-${currentPosition}`,
      `tooltip__triangles--align-${currentAlignment}`,
    )}
    style={{
      left: pos?.left,
      top: pos?.top,
      bottom: pos?.bottom,
      right: pos?.right,
    }}
  />
);

export default TooltipTriangleComponent;
